/*
 * Jira Ticket:
 * Created Date: Thu, 12th Mar 2020, 15:27:24 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Chip } from '@material-ui/core';
import { chipList as styles } from 'styles';

const EmploymentUserProject = ({ record }) => {
  const classes = styles();
  if (record && record.type) {
    if (record.type === 'EMPLOYEE') {
      return 'All';
    }
    return (
      record &&
      record.projects.map(project => (
        <Chip className={classes.root} label={project.name} key={project.id} />
      ))
    );
  }
  return null;
};
EmploymentUserProject.defaultProps = { addLabel: true };

export default EmploymentUserProject;
